// Could accept Ratio type import { Ratio } from 'ecosystem'
import { parseFloatSafe } from './numbers'

export const getAspectRatioAsNumber = (ratio?: string): number | undefined => {
  // Return undefined for empty, undefined, or dash values
  if (!ratio || ratio.trim() === '' || ratio.trim() === '-') {
    return undefined
  }

  // Check if the ratio contains a colon (format: "width:height")
  if (ratio.includes(':')) {
    const parts = ratio.split(':')

    // Ensure we have exactly 2 parts
    if (parts.length !== 2) {
      return undefined
    }

    const [widthStr, heightStr] = parts
    const width = parseFloatSafe(widthStr.trim())
    const height = parseFloatSafe(heightStr.trim())

    // Validate both numbers are valid and height is not zero
    if (!width || !height) {
      return undefined
    }

    return width / height
  }

  return undefined
}
